import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const useQuery = (key, defaultValue = null) => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search).get(key) || defaultValue, [search, key, defaultValue]);
}

export default useQuery;